import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TransactionChats } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemOutgoingTransaction from '../hooks/use-outgoing';

const OutgoingTransactionChats = (): React.JSX.Element => {
  const { chats, transaction, senderCompanyOfficials } = useAppSelector(
    (state) => state.customersProblemTransactions.outgoing,
  );
  const { currentEmployee } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList, activePermissions } = useAppSelector(
    (state) => state.root,
  );

  const { transactionId } = useParams();

  const { getSenderAccounts, onCreateTransactionChat, chatCreateInProgress } =
    useProblemOutgoingTransaction({
      transactionId,
      currenciesList,
      currentEmployee,
    });

  useEffect(() => {
    if (
      transaction &&
      transaction.senderAccount &&
      transaction.senderAccount?.organization?.type === 'CORPORATE' &&
      !senderCompanyOfficials
    ) {
      getSenderAccounts(transaction.senderAccount.organizationId);
    }
  }, [transaction, senderCompanyOfficials]);

  return (
    <TransactionChats
      chats={chats}
      companyOfficials={senderCompanyOfficials}
      individualCustomer={transaction?.senderAccount}
      onCreateTransactionChat={onCreateTransactionChat}
      chatCreateInProgress={chatCreateInProgress}
      currentEmployee={currentEmployee}
      activePermissions={activePermissions}
    />
  );
};

export default OutgoingTransactionChats;
